module.exports = __webpack_public_path__ + "static/media/male.4f8fdbdb.png";